import Tools from "@/components/Builder/Tools";
import StudentDashboardLayout from "@/components/Student/DashboardLayout";
import { useAuthContext } from "@/context/auth/AuthContext";
import Image from "next/image";
import { useEffect, useState } from "react";
import { Link } from "react-scroll";
import axios from "axios";
import { connectToDatabase } from "@/components/Server/Database/MongoDB";

const StudentProfile = ({ info }) => {
  const { user } = useAuthContext();
  const [state, setState] = useState(user);
  const [status, setStatus] = useState({ type: "danger", value: null });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setState(user);
  }, [user]);

  const inputs = [
    {
      element: "text",
      name: "firstName",
      label: "First Name",
      width: "col-md-6",
      required: true,
      placeholder: "Enter Your First Name",
    },
    {
      element: "text",
      name: "lastName",
      label: "Last Name",
      width: "col-md-6",
      required: true,
      placeholder: "Enter Your Last Name",
    },
    {
      element: "text",
      name: "email",
      label: "Email Address",
      width: "col-md-6",
      disabled: true,
      required: false,
      placeholder: "Enter Your Email Address",
    },
    {
      element: "text",
      name: "phone",
      label: "Contact Number",
      width: "col-md-6",
      disabled: true,
      required: false,
      placeholder: "Enter Your Contact / Phone Number",
    },
    {
      element: "text",
      name: "medicalSchoolName",
      label: "Medical School Name",
      width: "col-md-6",
      required: true,
      placeholder: "Enter Your Medical School Name",
    },
    {
      element: "select",
      items: "1st Year,2nd Year,3rd Year,4th Year,Graduate",
      name: "yearOfMedicalSchool",
      label: "Year of Medical School",
      width: "col-md-6",
      required: true,
      placeholder: "Enter the year of your medical school",
    },
   
  ];

  const passwordInputs = [
    {
      element: "password",
      name: "oldPassword",
      label: "Old Password",
      width: "col-md-12",
      required: true,
      placeholder: "Enter Your Old Password",
    },
    {
      element: "password",
      name: "newPassword",
      label: "New Password",
      width: "col-md-12",
      required: true,
      placeholder: "Enter Your New Password",
    },
    {
      element: "password",
      name: "cnfPassword",
      label: "Confirm Password",
      width: "col-md-12",
      required: true,
      placeholder: "Confirm Your New Password",
    },
  ];

  const socialInputs = [
    {
      element: "text",
      name: "facebook",
      label: "Facebook",
      width: "col-md-12",
      required: false,
      placeholder: "https://facebook.com/",
    },
    {
      element: "text",
      name: "twitter",
      label: "Twitter",
      width: "col-md-12",
      required: false,
      placeholder: "https://twitter.com/",
    },
    {
      element: "text",
      name: "linkedin",
      label: "Linkedin",
      width: "col-md-12",
      required: false,
      placeholder: "https://linkedin.com/",
    },
    {
      element: "text",
      name: "website",
      label: "Website",
      width: "col-md-12",
      required: false,
      placeholder: "https://website.com/",
    },
    {
      element: "text",
      name: "github",
      label: "Github",
      width: "col-md-12",
      required: false,
      placeholder: "https://github.com/",
    },
  ];

  const updateProfile = async (userData) => {
    setLoading(true);
    try {
      const response = await axios.put("/api/profile/edit", {
        email: user.email,
        data: {
          firstName: userData.firstName,
          lastName: userData.lastName,
        },
      });

      if (response.status === 200) {
        setStatus({ type: "success", value: "Profile Updated" });
      } else {
        setStatus({
          type: "danger",
          value:
            response.data.message || "An error occurred during profile update.",
        });
      }
    } catch (err) {
      setStatus({
        type: "danger",
        value: "There is an error. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  const updatePassword = async (passwordData) => {
    setLoading(true);
    try {
      const response = await axios.put("/api/auth/change-password", {
        email: user.email,
        oldPassword: passwordData.oldPassword,
        newPassword: passwordData.newPassword,
      });

      if (response.status === 200) {
        setStatus({ type: "success", value: "Password Updated" });
      } else {
        setStatus({
          type: "danger",
          value:
            response.data.message ||
            "An error occurred during password change.",
        });
      }
    } catch (err) {
      setStatus({
        type: "danger",
        value:
          err.response.data.message ||
          "There is an error. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <StudentDashboardLayout
      brand={JSON.parse(info)}
      sidebar={true}
      title="Student Profile - Online Courses & Education Powered By THEWEBVALE"
    >
      <div className="rbt-dashboard-content bg-color-white rbt-shadow-box">
        <div className="content">
          <div className="section-title">
            <h4 className="rbt-title-style-3">Settings</h4>
          </div>

          <div className="advance-tab-button mb--30">
            <ul
              className="nav nav-tabs tab-button-style-2 justify-content-start"
              id="settingsTab-4"
              role="tabList"
            >
              <li role="presentation">
                <a
                  className="tab-button active"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#profile"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="true"
                >
                  <span className="title">Profile</span>
                </a>
              </li>
              <li role="presentation">
                <a
                  className="tab-button"
                  id="password-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#password"
                  role="tab"
                  aria-controls="password"
                  aria-selected="false"
                >
                  <span className="title">Password</span>
                </a>
              </li>
              <li role="presentation">
                <a
                  className="tab-button"
                  id="social-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#social"
                  role="tab"
                  aria-controls="social"
                  aria-selected="false"
                >
                  <span className="title">Social Share</span>
                </a>
              </li>
            </ul>
          </div>
          {status.value && (
            <div className={`alert alert-${status.type}`}>{status.value}</div>
          )}
          <div className="tab-content">
            <div
              className="tab-pane fade active show"
              id="profile"
              role="tabPanel"
              aria-labelledby="profile-tab"
            >
              {/* <div className="rbt-dashboard-content-wrapper">
                <div className="tutor-bg-photo bg_image bg_image--23 height-245"></div>
                <div className="rbt-tutor-information">
                  <div className="rbt-tutor-information-left">
                    <div className="thumbnail rbt-avatars size-lg position-relative">
                      <Image
                        width={300}
                        height={300}
                        src="/images/team/avatar-2.jpg"
                        alt="Instructor"
                      />
                      <div className="rbt-edit-photo-inner">
                        <button className="rbt-edit-photo" title="Upload Photo">
                          <i className="feather-camera" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  updateProfile(state);
                }}
                className="rbt-profile-row rbt-default-form row row--15"
              >
                <Tools setState={setState} state={state} inputs={inputs} />
                <div className="col-12 mt--20">
                  <div className="rbt-form-group">
                    <button
                      className={`rbt-btn btn-gradient ${
                        loading ? "disabled" : ""
                      }`}
                      type="submit"
                    >
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div
              className="tab-pane fade"
              id="password"
              role="tabPanel"
              aria-labelledby="password-tab"
            >
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  updatePassword(state);
                }}
                className="rbt-profile-row rbt-default-form row row--15"
              >
                <Tools
                  setState={setState}
                  state={state}
                  inputs={passwordInputs}
                />
                <div className="col-12 mt--20">
                  <div className="rbt-form-group">
                    <button
                      className={`rbt-btn btn-gradient ${
                        loading ? "disabled" : ""
                      }`}
                      type="submit"
                    >
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div
              className="tab-pane fade"
              id="social"
              role="tabPanel"
              aria-labelledby="social-tab"
            >
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  updateProfile(state);
                }}
                className="rbt-profile-row rbt-default-form row row--15"
              >
                <Tools
                  setState={setState}
                  state={state}
                  inputs={socialInputs}
                />
                <div className="col-12 mt--20">
                  <div className="rbt-form-group">
                    <button
                      className={`rbt-btn btn-gradient ${
                        loading ? "disabled" : ""
                      }`}
                      type="submit"
                    >
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </StudentDashboardLayout>
  );
};

export const getServerSideProps = async (context) => {
  const domainName = context.req ? context.req.headers.host : null;

  const { db } = await connectToDatabase();

  const info = await db.collection("partners").findOne({
    key: process.env.DEFAULT || domainName,
  });

  if (!info) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      info: JSON.stringify(info),
    },
  };
};

export default StudentProfile;
